import React from "react";
import "./Clients.css";

function Clients() {
  const clients = [
    {
      name: "RAEC",
      logo: "/images/raec.webp",
    },
    {
      name: "Shell",
      logo: "/images/shell.webp",
    },
    {
      name: "Total",
      logo: "/images/total.webp",
    },
    {
      name: "NNPC",
      logo: "/images/nnpc.webp",
    },
        {
      name: "Chevron",
      logo: "/images/chevron.webp",
    },
        {
      name: "Seplat",
      logo: "/images/seplat.webp",
    },
  ];

  return (
    <section className="clients" id="clients">

      <div className="clients-container">

        {/* ==================================================
            HEADER
            ================================================== */}

        <div className="clients-header">

          <div className="clients-heading">

            <span className="clients-eyebrow">
              OUR PARTNERS
            </span>

            <h2>
              Trusted by
              <br />
              <span>Industry Leaders.</span>
            </h2>

          </div>

          <div className="clients-intro">

            <p>
              We build strong and lasting relationships with
              clients and partners across the energy and
              maritime sectors.
            </p>

          </div>

        </div>


        {/* ==================================================
            CLIENT LOGOS
            ================================================== */}

        <div className="clients-grid">

          {clients.map((client, index) => (

            <div
              className="client-logo"
              key={index}
            >

              {client.logo ? (
                <img
                  src={client.logo}
                  alt={client.name}
                />
              ) : (
                <span className="client-wordmark">
                  {client.name}
                </span>
              )}

            </div>

          ))}

        </div>


        {/* ==================================================
            BOTTOM STATEMENT
            ================================================== */}

        <div className="clients-bottom">

          <span className="clients-bottom-line"></span>

          <p>
            Strong partnerships.
            <strong> Greater impact.</strong>
          </p>

        </div>

      </div>

    </section>
  );
}

export default Clients;